import {useLocalSearchParams} from "expo-router";
import {QrInviteScreen} from "@/components/organization/QrInviteScreen";

export default function Invite() {
    const {orgId} = useLocalSearchParams<{orgId: string}>();
    return (
        <QrInviteScreen orgId={orgId}/>
    );
}
